import { render, staticRenderFns } from "./Keluar_permintaan.vue?vue&type=template&id=6a4f830e&scoped=true"
import script from "./Keluar_permintaan.vue?vue&type=script&lang=js"
export * from "./Keluar_permintaan.vue?vue&type=script&lang=js"
import style0 from "./Keluar_permintaan.vue?vue&type=style&index=0&id=6a4f830e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f830e",
  null
  
)

export default component.exports